import { useSessionStorage } from 'hooks';

const IsIframedInSeismic = ({ children, show = true }) => {
  const isIframedInSeismic = useSessionStorage('iframedInSeismic');

  if (!isIframedInSeismic) return children;
  if (isIframedInSeismic && show) return children;
  if (isIframedInSeismic && !show) return null;
  return null;
};

export default IsIframedInSeismic;
